import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
    color: '#333',
  },
  header: {
    marginBottom: 20,
    borderBottom: '1px solid #e0e0e0',
    paddingBottom: 10,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 4,
    color: '#1976d2',
  },
  headerSubtitle: {
    fontSize: 11,
    color: '#666',
  },
  summaryRow: {
    flexDirection: 'row',
    marginBottom: 20,
    gap: 12,
  },
  summaryCard: {
    flex: 1,
    padding: 10,
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
  },
  summaryLabel: {
    fontSize: 9,
    color: '#666',
    marginBottom: 4,
  },
  summaryValue: {
    fontSize: 13,
    fontWeight: 'bold',
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 6,
    marginTop: 14,
    color: '#1976d2',
  },
  table: {
    display: 'flex',
    width: '100%',
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #e0e0e0',
    paddingVertical: 4,
  },
  tableHeader: {
    backgroundColor: '#f0f4f8',
    fontWeight: 'bold',
  },
  tableCell: {
    flex: 1,
    padding: 4,
    fontSize: 9,
  },
  tableCellAmount: {
    width: 70,
    padding: 4,
    fontSize: 9,
    textAlign: 'right',
  },
  feeSection: {
    marginTop: 10,
    marginBottom: 4,
  },
  feeSectionTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#1565c0',
    backgroundColor: '#e3f0fb',
    paddingVertical: 5,
    paddingHorizontal: 6,
    marginBottom: 0,
  },
  subtotalRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #bdbdbd',
    backgroundColor: '#fafafa',
    paddingVertical: 4,
  },
  subtotalLabel: {
    flex: 1,
    padding: 4,
    fontSize: 9,
    fontWeight: 'bold',
    color: '#444',
    textAlign: 'right',
  },
  subtotalAmount: {
    width: 70,
    padding: 4,
    fontSize: 9,
    fontWeight: 'bold',
    color: '#444',
    textAlign: 'right',
  },
  comparisonMeta: {
    fontSize: 8,
    color: '#666',
    marginTop: 2,
  },
  deltaPositive: {
    color: '#2e7d32',
    fontSize: 9,
    fontWeight: 'bold',
  },
  deltaNegative: {
    color: '#c62828',
    fontSize: 9,
    fontWeight: 'bold',
  },
});
